import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { ResultComments } from "../shared/interfaces/ResultComments";

export function useResultComments(captureId: number, callbacks?: QueryCallbacks<ResultComments>) {
  const apiContext = useContext(ApiContext);
  return useQuery({
    queryKey: ["resultComments", captureId],
    queryFn: async () => {
      if (captureId) return await apiContext.resultsApis.getResultComments(captureId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
